import exceljs from "exceljs";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    mimeTypeMap, MyDate
} from "src/components/common/functions";

export default function Export({
    filteredOrganizations
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const exportFunc = () => {
        if(!filteredOrganizations.length){
            window.alert("No data to export.");
            return;
        }
    setShowLoader(true);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;
        const rows = filteredOrganizations.map(post => [
            post.organizationName, 
            post.website, 
            post.phoneNumber, 
            post.fax, 
            //------------
            post.street,
            post.city,
            post.state,
            post.postalCode,
            post.country,
            post.creator,
            post.dateCreated ?? "", 
            post.updater,
            post.dateUpdated ?? "", 
            //------------
            post.background
        ])
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            totalsRow: true,
            style: {
                showRowStripes: true,
            },
            columns: [
                { name: "Organization Name", filterButton: true},
                { name: "Website", filterButton: true},
                { name: "Phone Number", filterButton: true},
                { name: "Fax", filterButton: true},
                //-------------------------------
                { name: "Street", filterButton: true},
                { name: "City", filterButton: true},
                { name: "State", filterButton: true},
                { name: "Postal Code", filterButton: true},
                { name: "Country", filterButton: true},
                { name: "Creator", filterButton: true},
                { name: "Date Created", filterButton: true},
                { name: "Updater", filterButton: true},
                { name: "Date Updated", filterButton: true},
                //-------------------------------
                { name: "Background", filterButton: true}
            ],
            rows: rows,
        });
        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                // exclude row 1 ----------
                if(cell.row === 1) return;
                //-------------------------
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.3)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        worksheet.getRows(2, rows.length).forEach(row => {row.alignment = { vertical: "middle", horizontal: "center", wrapText: true }});
        worksheet.getColumn(14,/*#*/).alignment = {"wrapText": true, vertical: "top", horizontal: "left"};
        worksheet.getColumn(15,/*#*/).alignment = {"wrapText": true, vertical: "top", horizontal: "left"};
        worksheet.getColumn(16,/*#*/).alignment = {"wrapText": true, vertical: "top", horizontal: "left"};
        worksheet.getColumn(17,/*#*/).alignment = {"wrapText": true, vertical: "top", horizontal: "left"};
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `organizations export ${(new MyDate()).s()}.xlsx`);
            setShowLoader(false);
        })
    }
    return (
        <button type = "button" className = "headerButton" onClick = {exportFunc}>
            Export
        </button>
    )
}